<template>
  <div class="my-title pd-hrzt-30px">
    License <a href="https://opensource.org/licenses/MIT">MIT</a>
  </div>
</template>

<script>
export default {
  name: 'license'
}
</script>



// WEBPACK FOOTER //
// src/components/license/index.vue